const local = {

    en:{
       title: 'SIGN UP to CONDTROL WARRANTY SERVICE',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',

    regFormTitle: "SIGN UP",
    country: "Country",
    countryOptions: [
       { value: 'RU', label: 'Russia' },
       { value: 'BY', label: 'Belarus' },
       { value: 'KZ', label: 'Kazakhstan' },
    ],
    town: "City",
    fio: "Name",
    mail: "e-mail",
    phone: "Phone",
    login: "Login",
    apparea: 'Which customer segment do you belong to?',
    passw: "Password",
    sendbtn:"REGISTER",
    diy:"For home use",
    pro:"Professional user",

    },

    ru:{
       title: 'РЕГИСТРАЦИЯ',
 description: 'регистрация продуктов CONDTROL',
    keywords: 'регистрация, продление гарантии',

      regFormTitle: "РЕГИСТРАЦИЯ",
      country: "Страна",
      countryOptions: [
         { value: 'RU', label: 'Россия' },
         { value: 'BY', label: 'Беларусь' },
         { value: 'KZ', label: 'Казахстан' },
      ],
      town: "Город",
      fio: "ФИО",
      mail: "e-mail",
      phone: "Телефон",
      login: "Придумайте логин (транслит)",
      passw: "Придумайте пароль",
      apparea: 'К какому сегменту покупателей вы относитесь?',
      sendbtn:"ОТПРАВИТЬ",
      diy:"Частное лицо",
      pro:"Профессиональный пользователь",

    },

    de:{
       title: 'Anmeldung',
 description: 'CONDTROL product registration',
    keywords: 'registration, warranty prolongation',

    regFormTitle: "Anmeldung",
    country: "Land",
    countryOptions: [
       { value: 'RU', label: 'Russland' },
       { value: 'BY', label: 'Belarus' },
       { value: 'KZ', label: 'Kasachstan' },
    ],
    town: "Anschrift",
    fio: "Name",
    mail: "Email",
    phone: "Phone",
    login: "Login",
    passw: "Password",
    apparea:'Zu welchem ​​Kundensegment gehören Sie?',    
    sendbtn:"Senden",
    diy:"Für den Hausgebrauch",
    pro:"Beruflicher Benutzer",

    },

};

export default local;